<template>
    <div class="xcarzd">

        <v-tabs v-model="tab" background-color="transparent" color="basil" height="30px" grow>
            <v-tab> Datos </v-tab>
            <v-tab> Historial </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <Datos /> 
            </v-tab-item>

            <v-tab-item vv-show="false">
                <Historial />
            </v-tab-item>
        </v-tabs-items>
        
    </div>
  </template>
  
  <script>
import Datos from './edit_datos.vue'
import Historial from './edit_historial.vue'

  export default {
    components:{ Datos,Historial },
    data(){
      return{
        tab: null,
      }
    },
    methods:{
      
    },
    mounted(){
        
    }
  }
  </script>